import { Component, Inject, Input, OnInit, Optional } from '@angular/core';
import { IFormattedLocation } from '@models/interfaces/IFormattedLocation';
import { ILocation } from '@models/interfaces/ILocation';
import { NavigationToolsProviderService } from '@services/navigation-tools-provider/navigation-tools-provider.service';
import { isValidCoordinate } from '@utils/coordinates';
import { REQUEST_LOCALIZE } from '../../../schema/injection-token';
import { RequestLocalization } from '../../../schema/interfaces/request-localization';

interface ILocationFormatted extends ILocation, IFormattedLocation {}

@Component({
  selector: 'app-callcard-location-with-tools',
  templateUrl: './callcard-location-with-tools.component.html',
  styleUrls: ['./callcard-location-with-tools.component.scss']
})
export class CallcardLocationWithToolsComponent implements OnInit {
  @Input() title: string;
  @Input() location: ILocationFormatted;

  hasValidCoordinate: boolean = false;

  constructor(
    public navigationTools: NavigationToolsProviderService,
    @Optional()
    @Inject(REQUEST_LOCALIZE)
    public localizer: RequestLocalization
  ) {}

  ngOnInit() {
    this.hasValidCoordinate = isValidCoordinate([this.location.coordinate.x, this.location.coordinate.y]);
  }
}
